//Importing modules
import React, { useContext, useState, useReducer, useEffect } from "react";
import axios from "axios";
import ActiveCardCard from "./ActiveCardCard/ActiveCardCard"
import ErrorBoundary from "../../Utils/ErrorBoundary";
import AuthContext from "../../../context/auth-context"
import { useHistory } from "react-router-dom"
import { dataFetchReducer } from "../../Utils/requestUtils";
import { CircularProgress } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import NewCardDialog from "./NewCardDialog/NewCardDialog";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import * as S from './styles'
import CardListHeader from "./CardListHeader";
import PreviewCardListHeader from "./PreviewCardListHeader"
import ChargeCard from "./ChargeCard/ChargeCard";
import PreviewCard from "./ChargeCard/PreviewCard";

const pagarme = require('pagarme')

function ActiveCardInbox(props) {

    const { t } = useTranslation()
    const texts = {
        card_number: t("card_number"),
        cardholder_name: t("cardholder_name"),
        expiery_date: t("expiery_date"),
        active_card: t("active_card"),
        inactive_card: t("inactive_card")
    }

    const [processingPayment, setProcessingPayment] = useState(false);

    const handleCardEncryption = (card) => {
        pagarme.client.connect({ encryption_key: process.env.REACT_APP_PAGARME_ENCRYPTION_KEY })
            .then(client => {
                return client.security.encrypt(card)
            })
            .then(card_hash => {
                axios.post('/dash/billing/card', { card_hash: card_hash }).then(response => {
                    if (response.status === 200) {
                        setRefreshPage(!refreshPage)
                    } else {
                        alert('Falha ao registrar cartão - Entre em contato com o time CaaS')
                    }
                })
            })

    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const [transactionFailureSnackbar, setTransactionFailureSnackbar] = useState(false);

    const handleWalletPayment = () => {
        setProcessingPayment(true)
        axios.post('/dash/billing/payment').then(response => {
            if (response.status === 200 || response.status === 204) {
                setRefreshPage(!refreshPage);
            }
        }).catch(error => {
            console.log(error)
            if (error.response.status < 500) {
                setTransactionFailureSnackbar(true);
                return;
            };
            alert("Falha interna na requisição, por favor entre em contato com a equipe QI CaaS.")
        })
        sleep(2000).then(() => setProcessingPayment(false));
    }

    const format_cost = (wallet_item_events_data) => {
        let value = 0;
        for (let i = 0; i < wallet_item_events_data.length; i++) {
            value = value + wallet_item_events_data[i].amount;
        }
        return "R$" + (value / 10000).toFixed(2).toString().replace('.', ',');
    }

    let history = useHistory()
    let roles = useContext(AuthContext).user_data.roles
    if (!roles.includes("billing_viewer") && !roles.includes("read_charges") && !roles.includes("read_charges_preview")) {
        history.push("")
    }

    const [refreshPage, setRefreshPage] = useState(false)

    const [card, dispatchCard] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )

    const [openNewCardDialog, setOpenNewCardDialog] = useState(false);

    const [wallet, dispatchWallet] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )

    const [walletItemEvents, dispatchWalletItemEvents] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )

    const [charges, dispatchCharges] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )

    const [preview, dispatchPreview] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )

    useEffect(()=> {
        if(roles.includes('read_charges_preview')){
            dispatchPreview({ type: "data_fetch_init" })
            const timer = setTimeout(() => {
                axios.get('/dash/companies/preview')
                .then(response => {
                    if (response.status === 204) {
                        dispatchPreview({
                            type: "data_fetch_success",
                            payload: { message: "Nenhuma cobrança foi encontrada." }
                        })
                    }
                    else {
                        dispatchPreview({
                            type: "data_fetch_success",
                            payload: response.data
                        })
                    }
                }).catch(error => {
                    if ((error.response || {}).status === 403) dispatchPreview({ type: "data_fetch_failure_403" })
                    else if ((error.response || {}).status === 404) dispatchPreview({ type: "data_fetch_failure_404" })
                    else dispatchPreview({ type: "data_fetch_failure" })
                })
            }, 500);
            return () => {
                clearTimeout(timer)
            }
        }
    }, [roles])

    useEffect(()=> {
        if(roles.includes('read_charges')){
            dispatchCharges({ type: "data_fetch_init" })
            const timer = setTimeout(() => {
                axios.get('/dash/companies/charges')
                .then(response => {
                    if (response.status === 204) {
                        dispatchCharges({
                            type: "data_fetch_success",
                            payload: { message: "Nenhuma cobrança foi encontrada." }
                        })
                    }
                    else {
                        dispatchCharges({
                            type: "data_fetch_success",
                            payload: response.data
                        })
                    }
                }).catch(error => {
                    if ((error.response || {}).status === 403) dispatchCharges({ type: "data_fetch_failure_403" })
                    else if ((error.response || {}).status === 404) dispatchCharges({ type: "data_fetch_failure_404" })
                    else dispatchCharges({ type: "data_fetch_failure" })
                })
            }, 500);
            return () => {
                clearTimeout(timer)
            }
        }
    }, [roles])

    useEffect(() => {
        if(roles.includes("billing_viewer")){
            dispatchWalletItemEvents({ type: "data_fetch_init" })
            if (wallet.fetchedData) {
                const timer = setTimeout(() => {
                    axios.get(`/dash/companies/wallet_item_events?page_number=0&page_rows=10000&wallet_key=${wallet.fetchedData.wallet_key}`).then(response => {
                        if (response.status === 204) {
                            dispatchWalletItemEvents({
                                type: "data_fetch_success",
                                payload: { message: "Nenhuma carteira ativa foi encontrada." }
                            })
                        }
                        else {
                            dispatchWalletItemEvents({
                                type: "data_fetch_success",
                                payload: response.data
                            })
                        }
                    }).catch(error => {
                        if ((error.response || {}).status === 403) dispatchWalletItemEvents({ type: "data_fetch_failure_403" })
                        else if ((error.response || {}).status === 404) dispatchWalletItemEvents({ type: "data_fetch_failure_404" })
                        else dispatchWalletItemEvents({ type: "data_fetch_failure" })
                    })
                }, 500);
                return () => {
                    clearTimeout(timer)
                }
            }
        }

    }, [wallet, roles])

    useEffect(() => {
        if(roles.includes("billing_viewer")){
            dispatchWallet({ type: "data_fetch_init" })
            const timer = setTimeout(() => {
                axios.get('/dash/companies/wallet').then(response => {
                    if (response.status === 204) {
                        dispatchWallet({
                            type: "data_fetch_success",
                            payload: { message: "Nenhuma carteira ativa foi encontrada." }
                        })
                    }
                    else {
                        dispatchWallet({
                            type: "data_fetch_success",
                            payload: response.data
                        })
                    }
                }).catch(error => {
                    if ((error.response || {}).status === 403) dispatchWallet({ type: "data_fetch_failure_403" })
                    else if ((error.response || {}).status === 404) dispatchWallet({ type: "data_fetch_failure_404" })
                    else dispatchWallet({ type: "data_fetch_failure" })
                })
            }, 500);
            return () => {
                clearTimeout(timer)
            }
        }
    }, [refreshPage, roles])

    useEffect(() => {
        if(roles.includes("billing_viewer")){
            dispatchCard({ type: "data_fetch_init" })
            const timer = setTimeout(() => {
                axios.get('/dash/billing/card').then(response => {
                    if (response.status === 204) {
                        dispatchCard({
                            type: "data_fetch_success",
                            payload: { message: "Nenhum cartão ativo foi encontrado." }
                        })
                    }
                    else {
                        dispatchCard({
                            type: "data_fetch_success",
                            payload: response.data
                        })
                    }
                }).catch(error => {
                    if ((error.response || {}).status === 403) dispatchCard({ type: "data_fetch_failure_403" })
                    else if ((error.response || {}).status === 404) dispatchCard({ type: "data_fetch_failure_404" })
                    else dispatchCard({ type: "data_fetch_failure" })
                })
            }, 500);
            return () => {
                clearTimeout(timer)
            }
        }
        
    }, [refreshPage, roles])

    const previewContainer = (preview) => {        
		if (!preview) {
			return (
			<div className='emptyContainer'>
				<p className={["blueText", "subtitleSize"].join(" ")}>
					Nenhuma prévia encontrada
				</p>
			</div>
			)
		}

		else {
            return (
                <div className='cardContainer'>
                    <PreviewCardListHeader />
                    <ErrorBoundary key={preview.charge_key}>
                        <PreviewCard charge={preview} />
                    </ErrorBoundary>
                </div>
            )
		}
	}

    const contentContainer = (dataList) => {        
		let nr_of_cards = dataList['data'].length
		let cards = dataList['data'].map((charge) => (
			<ErrorBoundary key={charge.charge_key}>
				<ChargeCard charge={charge} />
			</ErrorBoundary>
		))

		if (nr_of_cards === 0) {
			return (
			<div className='emptyContainer'>
				<p className={["blueText", "subtitleSize"].join(" ")}>
					Nenhuma fatura encontrada
				</p>
			</div>
			)
		}

		else {
            return (
                <div className='cardContainer'>
                    <CardListHeader />
                    {cards}
                </div>
            )
		}
	}

    let charges_preview_component = <></>

    if (roles.includes('read_charges_preview')){
        if (preview.fetchedData) {
            charges_preview_component = <S.Container>
                <S.Heading>
                    <S.Title>{t("invoice_preview")}</S.Title>
                </S.Heading>
                {previewContainer(preview.fetchedData)}
            </S.Container>
        } else if (preview.isError){
            charges_preview_component = <S.Container>
                <S.Heading>
                    <S.Title>{t("invoice_preview")}</S.Title>
                </S.Heading>
                <S.NoCardContainer>
                    <S.NotificationTitle>{t("charge_preview_error_message")}</S.NotificationTitle>
                    <S.Message>{preview.errorMessage}</S.Message>
                </S.NoCardContainer>
            </S.Container>
        } else if (preview.isLoading) {
            charges_preview_component = <S.Container>
                <S.Heading>
                <S.Title>{t("invoice_preview")}</S.Title>
                </S.Heading>
                <CircularProgress />
            </S.Container>
        }
    }

    let charges_list_component = <></>
    if (roles.includes('read_charges')) {
        if (charges.fetchedData){
            charges_list_component = <S.Container>
                <S.Heading>
                    <S.Title>{t("invoices")}</S.Title>
                </S.Heading>
                {contentContainer(charges.fetchedData)}
            </S.Container>
        } else if (charges.isError) {
            charges_list_component = <S.Container>
                <S.Heading>
                    <S.Title>{t("invoices")}</S.Title>
                </S.Heading>
                <S.NoCardContainer>
                    <S.NotificationTitle>{t("charges_error_message")}</S.NotificationTitle>
                    <S.Message>{charges.errorMessage}</S.Message>
                </S.NoCardContainer>
            </S.Container>
        } else if (charges.isLoading) {
            charges_list_component = <S.Container>
                <S.Heading>
                    <S.Title>{t("invoices")}</S.Title>
                </S.Heading>
                <CircularProgress />
            </S.Container>
        }
    }


    let billing_viewer_component = <></>
    if (roles.includes('billing_viewer')) {
        if (card.fetchedData) {
            if (card.fetchedData.message) {
                billing_viewer_component = (
                    <S.Container>
                        <S.Heading>
                            <S.Title>{t("payments")}</S.Title>
                        </S.Heading>
                        <S.NoCardContainer>
                            <S.NotificationTitle>{t("no_card_notification")}</S.NotificationTitle>
                            <S.Message>{t("no_card_description")}</S.Message>
                            <S.AddCardButton onClick={() => setOpenNewCardDialog(true)}><S.ButtonText>{t("register_credit_card")}</S.ButtonText></S.AddCardButton>
                        </S.NoCardContainer>
                        <NewCardDialog open={openNewCardDialog} onSuccess={handleCardEncryption} onClose={() => setOpenNewCardDialog(false)} setRefreshPage={() => setRefreshPage(!refreshPage)} />
                    </S.Container>
                )
            }
            else {
                billing_viewer_component = (
                    <S.Container>
                        <S.Heading>
                            <S.Title>
                                {t("payments")}
                            </S.Title>
                        </S.Heading>
                        <S.ActiveCardContainer>
                            <S.NotificationTitle>{t("registered_credit_card")}</S.NotificationTitle>
                            <ErrorBoundary>
                                <ActiveCardCard card={card.fetchedData} texts={texts} refresh={() => setRefreshPage(!refreshPage)} />
                            </ErrorBoundary>
                            <S.AddCardButton onClick={() => setOpenNewCardDialog(true)}><S.ButtonText>{t("register_another_card")}</S.ButtonText></S.AddCardButton>
                        </S.ActiveCardContainer>
                        {wallet.fetchedData && wallet.fetchedData.wallet_status.enum === 'pending_payment' && walletItemEvents.fetchedData ?
                            <S.ActiveCardContainer>
                                <S.NotificationTitle>Pagamentos pendentes</S.NotificationTitle>
                                <S.Message>Para ativar sua carteira, realize o pagamento das pendências de plano e consumo de sua conta.</S.Message>
                                {processingPayment ? <S.AddCardButton gray onClick={() => { }}><S.ButtonText>{t('in_processing')}</S.ButtonText><CircularProgress style={{ width: "12px", height: "12px", margin: "auto", color: "white" }} /></S.AddCardButton>
                                    :
                                    <S.AddCardButton onClick={handleWalletPayment}><S.ButtonText>Realizar o pagamento:</S.ButtonText><S.ButtonText>{format_cost(walletItemEvents.fetchedData.data)}</S.ButtonText></S.AddCardButton>
                                }
                            </S.ActiveCardContainer>
                            : <></>}
                        {wallet.fetchedData && wallet.fetchedData.wallet_status.enum === 'frozen' && walletItemEvents.fetchedData ?
                            <S.ActiveCardContainer>
                                <S.NotificationTitle>Pagamentos pendentes</S.NotificationTitle>
                                <S.Message>Para reativar sua carteira, realize o pagamento dos consumos extras que foram realizados.</S.Message>
                                {processingPayment ? <S.AddCardButton gray onClick={() => { }}><S.ButtonText>{t('in_processing')}</S.ButtonText><CircularProgress style={{ width: "12px", height: "12px", margin: "auto", color: "white" }} /></S.AddCardButton>
                                    :
                                    <S.AddCardButton onClick={handleWalletPayment}><S.ButtonText>Realizar o pagamento: </S.ButtonText><S.ButtonText>{format_cost(walletItemEvents.fetchedData.data)}</S.ButtonText></S.AddCardButton>
                                }
                            </S.ActiveCardContainer>
                            : <></>}
                        <NewCardDialog open={openNewCardDialog} onSuccess={handleCardEncryption} onClose={() => setOpenNewCardDialog(false)} setRefreshPage={() => setRefreshPage(!refreshPage)} />
                        <Snackbar
                            open={transactionFailureSnackbar}
                            autoHideDuration={12000}
                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                            onClose={() => setTransactionFailureSnackbar(false)}
                        >
                            <Alert variant="filled" severity="error">
                                {t('Sua transação foi recusada. Se isso se trata de um erro, entre em contato com a equipe de suporte QI Tech KYC.')}
                            </Alert>
                        </Snackbar>
                    </S.Container>
                )
            }
        } else if (card.isError) {
            billing_viewer_component = <S.Container>
                <S.Heading>
                    <S.Title>{t("payments")}</S.Title>
                </S.Heading>
                <S.NoCardContainer>
                    <S.NotificationTitle>{t("card_recovery_error_message")}</S.NotificationTitle>
                    <S.Message>{card.errorMessage}</S.Message>
                </S.NoCardContainer>
            </S.Container>
        } else if (card.isLoading) {
            billing_viewer_component = <S.Container>
                <S.Heading>
                    <S.Title>{t("payments")}</S.Title>
                </S.Heading>
                <CircularProgress />
            </S.Container>
        }

    }

    return <>
            <div style={{margin: '20px 0'}}>
                {charges_preview_component}   
            </div>
            <div style={{margin: '20px 0'}}>
                {charges_list_component}
            </div>
            <div style={{margin: '20px 0'}}>
                {billing_viewer_component}
            </div>
        </>

}



//Exporting component
export default ActiveCardInbox
